import { Component, Input } from '@angular/core';
import { GenericLinkComponent } from '@spartacus/storefront';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-download-link',
    templateUrl: './download-link.component.html',
    imports: [NgClass, NgTemplateOutlet, RouterLink]
})
export class DownloadLinkComponent extends GenericLinkComponent {
  @Input() url: string;
  @Input() target: string;
  @Input() classes: string[];
}
